import { render, staticRenderFns } from "./PopupSystemNotice.vue?vue&type=template&id=538947ca"
import script from "./PopupSystemNotice.vue?vue&type=script&lang=js"
export * from "./PopupSystemNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports